/**
 * This function takes an input, meant to represent a number or an intermediate value during number entry,
 * and returns either a number, an intermediate string, or a dash ('-').
 * It's primarily used to handle scenarios where the input could be in the process of entering a negative decimal number.
 * In such cases, intermediate values like "-" or "-." could cause premature conversion to NaN in some environments.
 *
 * @param {any} input - The input to be evaluated and possibly converted into a number.
 * @returns {number | string} - Returns a number if the input can be converted into a number without creating NaN.
 *                             Returns '-' or '-.' if the input is an intermediate value in the entry of a negative decimal number.
 *                             Returns the original string input for all other cases.
 */
export default function getNumberOrIntermediateString(input) {
    if (typeof input === 'number')
        return input;
    if (input === undefined || input === null)
        return '';
    const strInput = String(input);
    if (['-', '-0', ''].includes(strInput) || strInput.match(/^-?\d*\.$/))
        return strInput;
    const num = Number(strInput);
    return isNaN(num) ? strInput : num;
}
